<template>
    <div v-if="error">
        <p class="input-error-text mt-2">
          {{ error }}
        </p>
    </div>
</template>

<script>
export default {
    props: ["error"]
};
</script>

<style scoped lang="scss">
.input-error-text {
    font-family: "Montserrat";
    font-size: 10px;
    font-weight: 500;
    line-height: normal;
    color: #da6844;
}
</style>
